// @flow
import { createAction } from 'redux-actions';
import {
    LEAK_SENSOR_LOAD_PAGE,
    LEAK_SENSOR_LOAD_SELECTED_DAY_EVENTS,
    LEAK_SENSOR_PAGE_READY,
    LEAK_SENSOR_RECEIVE_EVENTS,
    LEAK_SENSOR_SET_CURRENT_DAY,
    LEAK_SENSOR_UNLOAD_PAGE
} from './constants';

export const leakSensorLoadPage = createAction(LEAK_SENSOR_LOAD_PAGE);

export const leakSensorLoadSelectedDayEvents = createAction(LEAK_SENSOR_LOAD_SELECTED_DAY_EVENTS);

export const leakSensorPageReady = createAction(LEAK_SENSOR_PAGE_READY);

export const leakSensorReceiveEvents = createAction(LEAK_SENSOR_RECEIVE_EVENTS, (day, data, id) => ({
    day,
    data,
    id
}));

export const leakSensorSetCurrentDay = createAction(LEAK_SENSOR_SET_CURRENT_DAY);

export const leakSensorUnloadPage = createAction(LEAK_SENSOR_UNLOAD_PAGE);



// WEBPACK FOOTER //
// ./src/core/state/products/leak-sensor/actions.js